import { useState } from "react";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';

const SellerCentral = ({ asin, settingsData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const marketplaceDomain =
    settingsData?.defaultvalues?.marketplace || "amazon.com";

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

 const openAmazonPage = (type) => {
    const marketplaceConfig = {
      "amazon.com": { id: "ATVPDKIKX0DER", domain: "sellercentral.amazon.com" }, // US
      "amazon.co.uk": {
        id: "A1F83G8C2ARO7P",
        domain: "sellercentral.amazon.co.uk",
      }, // UK
      "amazon.de": { id: "A1PA6795UKMFR9", domain: "sellercentral.amazon.de" }, // Germany
      "amazon.fr": { id: "A13V1IB3VIYZZH", domain: "sellercentral.amazon.fr" }, // France
      "amazon.it": { id: "APJ6JRA9NG5V4", domain: "sellercentral.amazon.it" }, // Italy
      "amazon.es": { id: "A1RKKUPIHCS9HS", domain: "sellercentral.amazon.es" }, // Spain
      "amazon.ca": { id: "A2EUQ1WTGCTBG2", domain: "sellercentral.amazon.ca" }, // Canada
    };

    const { id: marketplaceId, domain: sellerCentralDomain } =
      marketplaceConfig[marketplaceDomain] || marketplaceConfig["amazon.com"];

    const baseParams = `?_encoding=UTF8&mons_sel_best_mkid=amzn1.mp.o.${marketplaceId}&ld=AMZUDP&coliid=&colid=&qid=&sr=`;

    const urls = {
      addProduct: `https://${sellerCentralDomain}/abis/listing/syh/ref=udp_sdp_sell${baseParams}&asin=${asin}`,
      inventory: `https://${sellerCentralDomain}/myinventory/inventory?fulfilledBy=all&page=1&pageSize=25&searchField=all&searchTerm=${asin}&sort=date_created_desc&status=all`,
      orders: `https://${sellerCentralDomain}/orders-v3/search?page=1&q=${asin}&qt=asin&date-range=last-365`,
      home: `https://${sellerCentralDomain}`,
    };

    const url = urls[type] || urls.home;
    window.open(url, "_blank");
  };

  return (
    <div
      className="flex flex-col w-full"
    >
      <div
        className="flex items-center gap-2 text-primary text-md font-bold cursor-pointer justify-between"
        onClick={toggleAccordion}
      >
        <p className="text-primary text-md font-bold">Seller Central</p>
        <div className="text-primary">
          {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
        </div>
      </div>

      {isOpen && (
        <div className="flex sm:flex-row flex-col gap-2 py-3">
          <button
            onClick={() => openAmazonPage("addProduct")}
            className="bg-primary text-primary-dark font-sm font-bold py-1.5 px-2 rounded-lg w-full"
          >
            Add Product
          </button>

          <button
            onClick={() => openAmazonPage("inventory")}
            className="bg-primary text-primary-dark font-sm font-bold py-1.5 px-2 rounded-lg w-full"
          >
            Inventory
          </button>

          <button
            onClick={() => openAmazonPage("orders")}
            className="bg-primary text-primary-dark font-sm font-bold py-1.5 px-2 rounded-lg w-full"
          >
            Orders
          </button>
        </div>
      )}
    </div>
  );
};

export default SellerCentral;
